<template>
  <div class="logo-w">
    <img :src="logoSrc" class="w-100" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const tenantKey = process.env.VUE_APP_TENANT_KEY

const logoSrc = computed(() => {
  switch (tenantKey) {
    case 'bsg':
      return require('@/assets/img/bsg-logo.png')

    case 'bbq':
      return require('@/assets/img/bbq-logo.png')

    default:
      return require('@/assets/img/default-logo.png')
  }
})
</script>